import NavBar from './navbar';
import NavMenu from './navmenu';
import { useAppDispatch, useAppSelector } from '../slices/index';
import * as UI from '../slices/uiSlice';
import * as Cases from '../slices/casesSlice';
import { AnyAction } from '@reduxjs/toolkit';
import '../App.css';
import icon_team from '../assets/The_Team_White.svg';
import leading_the_way from '../assets/Leading_The_Way_Conveyancing.svg';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';

const Teams = () => {
	const dispatch = useAppDispatch();
	const cases = useAppSelector(state => state.cases);
	const navigate = useNavigate();

	const handleScroll = () => {
		dispatch((UI.closeMenu()) as unknown as AnyAction);
	};

	useEffect(() => {
		if (!cases.case.caseno) {
			navigate('/hub');
		}
	}, [])

	return (
		<div className="Home">
			<div style={{ position: 'absolute', top: 96, left: 0, right: 0, bottom: 80 }}>
				<div className='OrangeBand'>
					<div style={{ marginLeft: 'calc(10% + 144px)', marginRight: '10%', width: 'calc(80% - 144px)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
						<div style={{ display: 'flex', alignItems: 'center' }}>
							<img style={{ width: 96, height: 96, marginRight: 8 }} src={icon_team} alt='Team-Icon' />
							<div style={{ marginLeft: 24 }}>
								<div style={{ fontFamily: 'OpenSans-Bold', fontSize: 36, marginBottom: 12, whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Meet the Teams</div>
							</div>
						</div>
					</div>
				</div>

				<div style={{ position: 'absolute', top: 144, left: 0, right: 0, bottom: 0, overflowY: 'scroll' }} onScroll={handleScroll}>
					<div style={{ maxWidth: 960, margin: 'auto', padding: 16, color: 'black', paddingTop: 16 }}>
						{(cases.teams || []).map((item: Cases.teamState) => {
							return (
								<div>
									<div style={{ display: 'flex', margin: '0 0' }}>
										<div style={{ fontFamily: 'OpenSans-Bold', fontSize: 28, color: '#4BC0E1' }}>{item.teamname}</div>
									</div>
									<div style={{ display: 'flex', margin: '0 0', flexWrap: 'wrap', width: '100%' }}>
										<div style={{ display: 'flex', margin: '4px 0', width: '50%' }}>
											<div style={{ display: 'flex', margin: 4, backgroundColor: '#4BC0E1', width: '100%', borderRadius: 16, alignItems: 'center' }}>
												<div style={{ display: 'flex', alignItems: 'start', margin: '0 0', backgroundColor: 'white' }}>
													<img style={{ width: 128, height: 128, objectFit: 'cover', objectPosition: 'center top', borderTopLeftRadius: 16, borderBottomLeftRadius: 16 }} src={process.env.REACT_APP_API_BACKEND_URL + 'getportrait.php?name=' + encodeURIComponent(item.name)} alt={item.name}></img>
												</div>
												<div style={{ padding: '0 8px', color: 'white' }}>
													<div style={{ fontSize: 28, fontFamily: 'OpenSans-Bold' }}>{item.name?.replace(/[0-9]/g, '')}</div>
													<div style={{ fontSize: 13 }}>{item.job}</div>
												</div>
											</div>
										</div>
										{(item.members || []).map((item: Cases.teamMemberState) => {
											return (
												<div style={{ display: 'flex', margin: '4px 0', width: '50%' }}>
													<div style={{ display: 'flex', margin: 4, backgroundColor: '#4BC0E1', width: '100%', borderRadius: 16, alignItems: 'center' }}>
														<div style={{ display: 'flex', alignItems: 'start', margin: '0 0', backgroundColor: 'white' }}>
															<img style={{ width: 128, height: 128, objectFit: 'cover', objectPosition: 'center top', borderTopLeftRadius: 16, borderBottomLeftRadius: 16 }} src={process.env.REACT_APP_API_BACKEND_URL + 'getportrait.php?name=' + encodeURIComponent(item.name)} alt={item.name}></img>
														</div>
														<div style={{ padding: '0 8px', color: 'white' }}>
															<div style={{ fontSize: 28, fontFamily: 'OpenSans-Bold' }}>{item.name?.replace(/[0-9]/g, '')}</div>
															<div style={{ fontSize: 13 }}>{item.job}</div>
														</div>
													</div>
												</div>
											)
										})}
									</div>
								</div>
							)
						})}
					</div>
				</div>
			</div>

			<div className='mainFooter'>
				<div style={{ marginLeft: '10%', marginRight: '10%', width: '80%', marginTop: 18 }}>
					<img style={{ height: 28 }} src={leading_the_way} alt='LeadingTheWay-Banner' />
				</div>
			</div>
			<div className='loginFooter'></div>
			<NavMenu />
			<NavBar />
		</div>
	);
}

export default Teams;